import { autoserializeAs, inheritSerialization } from 'cerialize';
import { LocationAddress } from './location-address';
import { RideRequestLocation } from './ride-request-location';

@inheritSerialization(RideRequestLocation)
export class RideRequestLocationDetail extends RideRequestLocation {
  @autoserializeAs(LocationAddress)
  locationAddress: LocationAddress;
}
